import { token } from '@atlaskit/tokens';
import { css } from '@compiled/react';
import { AdControls } from '@post-office/components--ad-controls';
import { type ComponentProps, type FunctionComponent } from 'react';

type PropsWithOnDismissed = {
	whyAmISeeingThisModalContent?: ComponentProps<typeof AdControls>['whyAmISeeingThisModalContent'];
	handleOnDismissed: () => void;
};

const actionsStyles = css({
	position: 'absolute',
	display: 'flex',
	top: '0',
	right: '0',
	padding: `${token('space.100', '8px')} ${token('space.100', '8px')} ${token('space.100', '8px')} 0`,
});

export const Actions: FunctionComponent<PropsWithOnDismissed> = ({
	whyAmISeeingThisModalContent,
	handleOnDismissed,
}) => {
	return (
		<div css={actionsStyles}>
			<AdControls
				iconSize="small"
				showWhyAmISeeingThis={true}
				whyAmISeeingThisModalContent={whyAmISeeingThisModalContent}
				onDismissed={handleOnDismissed}
			/>
		</div>
	);
};
